import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '*', redirect: '/' },
  {
    path: '/',
    name: 'timetable',
    component: () => import('../views/timetableHome.vue')
  },
  {
    path: '/group/:idGroup/:fromdate?',
    component: () => import('../views/timetable.vue')
  },
  {
    path: '/lecturer/:idLecturer/:fromdate?',
    component: () => import('../views/timetable.vue')
  },
  {
    path: '/auditory/:idAuditory/:fromdate?',
    component: () => import('../views/timetable.vue')
  },
  {
    path: '/faculty/:idFaculty/:fromdate?',
    component: () => import('../views/timetableCategories.vue')
  },
  {
    path: '/corps/:idBuilding',
    component: () => import('../views/timetableCategories.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
